import EventEmitter from 'eventemitter3';

/**
 * Shared EventEmitter instance for AIConversation avatar events
 */
export const avatarEventBus = new EventEmitter();

// Type-safe event names
export const AvatarEvents = {
    // AI Context and Message Events
    AI_INIT_MESSAGGE: 'AI_INIT_MESSAGGE',
    AI_CONTEXT_CHANGED: 'AI_CONTEXT_CHANGED',
    AI_REPEATING_MESSAGE: 'AI_REPEATING_MESSAGE',
    AI_STREAMING_REPEAT_MESSAGE: 'AI_STREAMING_REPEAT_MESSAGE',
    AI_STREAMING_AUDIO_MESSAGE: 'AI_STREAMING_AUDIO_MESSAGE',
    AI_REPEATING_MESSAGE_START: 'AI_REPEATING_MESSAGE_START',
    AI_REPEATING_MESSAGE_STOP: 'AI_REPEATING_MESSAGE_STOP',
    AI_VOICE_CHANGED: 'AI_VOICE_CHANGED',

    // Lip Sync Events (Regular TTS)
    LIP_SYNC_MESSAGE_START: 'LIP_SYNC_MESSAGE_START',
    LIP_SYNC_MESSAGE_STOP: 'LIP_SYNC_MESSAGE_STOP',
    LIP_SYNC_DATA: 'LIP_SYNC_DATA',

    // Lip Sync Events (Streaming Audio)
    LIP_SYNC_STREAMING_AUDIO_START: 'LIP_SYNC_STREAMING_AUDIO_START',
    LIP_SYNC_STREAMING_AUDIO_STOP: 'LIP_SYNC_STREAMING_AUDIO_STOP',
    LIP_SYNC_STREAMING_AUDIO_DATA: 'LIP_SYNC_STREAMING_AUDIO_DATA',

    // Lottie Animation Events
    LOTTIE_ANIMATION_LOAD: 'lottie-animation-load',
    LOTTIE_MAIN_ANIMATION_LOADED: 'lottie-main-animation-loaded',
    LOTTIE_MOUTH_ANIMATION_LOADED: 'lottie-mouth-animation-loaded',
    LOTTIE_STATE_CHANGE: 'lottie-state-change',
    LOTTIE_STATE_START: 'lottie-state-start',
    LOTTIE_STATE_END: 'lottie-state-end',
    LOTTIE_ANIMATION_COMPLETE: 'lottie-animation-complete',
    LOTTIE_MOUTH_CHANGE: 'lottie-mouth-change',
    LOTTIE_MOUTH_SET: 'lottie-mouth-set',
    LOTTIE_TRANSITION_REQUEST: 'lottie-transition-request',
    LOTTIE_TRANSITION_FAILED: 'lottie-transition-failed',
    LOTTIE_LIP_SYNC_START: 'lottie-lip-sync-start',
    LOTTIE_ANIMATION_PAUSE: 'lottie-animation-pause',
    LOTTIE_ANIMATION_RESUME: 'lottie-animation-resume',
} as const;

export type AvatarEventName = typeof AvatarEvents[keyof typeof AvatarEvents];

